import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { LayoutService } from '../../../service/layout.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';

export type ConfirmationDialogComponentData = {
  /** The text to ask to user */
  text: string,
  /** Param to replace into text (only for translation) */
  param?: any,
  /** if true, show just OK button, else show the 'yes' and 'no' buttons  */
  uniqueAction?: boolean,
  /** if true, also show a 'cancel' button; cancel (and backdrop click) closes with `undefined`, 'no' closes with `false` */
  showCancel?: boolean,
  /** (optional) link to access when click OK button */
  link?: string,
  /** Set true to avoid translations. by default the text is translated with `CONFIRMATION.${text}` */
  noTranslate?: boolean
  /** @deprecated string svg to use as MatIcon */
  svg?: any,
}

@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,

    MatDialogTitle,
    MatDialogActions,
    MatButton
  ],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent implements OnInit, AfterViewInit {

  sub: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogComponentData,
    public layout: LayoutService,
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {
    if (data.svg) {
      this.iconRegistry.addSvgIconLiteral('icon', this.sanitizer.bypassSecurityTrustHtml(data.svg));
    }
  }

  ngOnInit() {
    this.layout.loader = false;
    this.sub = this.dialogRef.backdropClick().subscribe(() => this.dialogRef.close());
  }

  ngAfterViewInit(): void {
    const paragraphs = document.querySelectorAll("p.session-data")

    paragraphs.forEach(paragraph => {
      paragraph.setAttribute("style", "font-size: 1rem;");
    })
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  onClickYes() {
    if (this.data.link) {
      window.open(this.data.link);
    }
    this.dialogRef.close(true);
  }

  onClickNo() {
    this.dialogRef.close(false);
  }

  onClickCancel() {
    this.dialogRef.close(undefined);
  }
}

